define([
	"dojo/_base/declare",
	"csi/table/New",
], function(declare, New) {

	return declare(New, {

		/**
		 * @override
		 * Disable Save & Go on this form
		 */
		_canNavigate: function() {
			return false;
		},

		/**
		 * @override
		 * Disable Save & New
		 */
		_canRepeat: function() {
			return false;
		},
	});
});
